import { convertArrayToKeyValue } from "../helpers/helpers";

export const SET_SEARCH_TERM = "SET_SEARCH_TERM";
export const SET_LOCATIONS = "SET_LOCATIONS";
export const SET_LOCATION = "SET_LOCATION";
export const SET_FILTER_ITEMS = "SET_FILTER_ITEMS";
export const SET_SEARCH_RESULT = "SET_SEARCH_RESULT";
export const SET_ERA_CONTENT = "SET_ERA_CONTENT";
export const SET_DIFF_ERAS_CONTENT = "SET_DIFF_ERAS_CONTENT";
export const SET_FILTERS = "SET_FILTERS";
export const SET_MUNICIPALITIES = "SET_MUNICIPALITIES";
export const SET_STORY_TAGS = "SET_STORY_TAGS";
export const SET_TAGS_FILTER = "SET_TAGS_FILTER";
export const SET_LOCATIONS_NEAR = "SET_LOCATIONS_NEAR";
export const SET_USER_LOCATION = "SET_USER_LOCATION";
export const SET_SEARCH_ERROR = "SET_SEARCH_ERROR";
export const SET_FOOTER_PAGES = "SET_FOOTER_PAGES";
export const SET_ERA_CHURCHES = "SET_ERA_CHURCHES";
export const SET_SELECTED_STORIES = "SET_SELECTED_STORIES";
export const SET_NEWS_BOX = "SET_NEWS_BOX";
export const HOMEPAGE_LOADED = "HOMEPAGE_LOADED";

// ===========================
// SEARCH
// ===========================

export function setSearchTerm(data) {
    return {
        type: SET_SEARCH_TERM,
        data,
    };
}

export function setSearchResult(data, nextPage, totalAvailable, reload) {
    return {
        type: SET_SEARCH_RESULT,
        data,
        nextPage,
        totalAvailable,
        reload,
    };
}

export function setLocations(data) {
    return {
        type: SET_LOCATIONS,
        data,
    };
}

export function setUserLocation(data) {
    return {
        type: SET_USER_LOCATION,
        data,
    };
}

export function setLocationsNear(data, nextPage, totalAvailable) {
    return {
        type: SET_LOCATIONS_NEAR,
        data,
        nextPage,
        totalAvailable,
    };
}

export function setLocation(data) {
    return {
        type: SET_LOCATION,
        data,
    };
}

export function setFilterItems(data) {
    return {
        type: SET_FILTER_ITEMS,
        data,
    };
}

export function setMunicipalities(data) {
    return {
        type: SET_MUNICIPALITIES,
        data,
    };
}

export function setFilters(data) {
    // TODO: Refactor those filter. Maybe Backend should return those as key value arrays
    // Rewrite text from data source

    if (data && data.hasOwnProperty("eras")) {
        const mappedEras = data.eras.map((item) => {
            let mappedItem = { key: "", value: "" };
            switch (item) {
            case "MiddleAges":
                mappedItem.key = item;
                mappedItem.value = "Middelalder";
                break;
            case "SeventeenthCentury":
                mappedItem.key = item;
                mappedItem.value = "1600-tallet";
                break;
            case "EighteenthCentury":
                mappedItem.key = item;
                mappedItem.value = "1700-tallet";
                break;
            case "NineteenthCentury":
                mappedItem.key = item;
                mappedItem.value = "1800-tallet";
                break;
            case "TwentiethCentury":
                mappedItem.key = item;
                mappedItem.value = "1900-tallet";
                break;
            case "TwentyFirstCentury":
                mappedItem.key = item;
                mappedItem.value = "2000-tallet";
                break;
            }
            return mappedItem;
        });
        data.eras = mappedEras;
    }

    if (data && data.hasOwnProperty("protectionStatuses")) {
        const newProtectionStatus = data.protectionStatuses.map((item) => {
            let newItem = { key: "", value: "" };

            switch (item) {
            case "Ingen vernestatus (E1)":
            case "Ingen (E1)":
                newItem.key = item;
                newItem.value = "Ingen vernestatus";
                break;
            case "Listeført (etter 1850) (D1)":
                newItem.key = item;
                newItem.value = "Listeført (etter 1850)";
                break;
            case "Automatisk listeført (1650-1850) (C1)":
                newItem.key = item;
                newItem.value = "Automatisk listeført (1650-1850)";
                break;
            // TODO: Remove this field from backend duplication!
            case "Automatisk fredet (før 1650) (B1)":
            case "Automatisk fredet (før 1650)":
                newItem.key = item;
                newItem.value = "Automatisk fredet (før 1650)";
                break;
            case "Vedtaksfredet (etter 1850) (B3)":
                newItem.key = item;
                newItem.value = "Vedtaksfredet (etter 1850)";
                break;
            case "Vedtaksfredet (1650-1850) (B2)":
                newItem.key = item;
                newItem.value = "Vedtaksfredet (1650-1850)";
                break;
            case "B5 Midlertidig fredet (etter 1850)":
                newItem.key = item;
                newItem.value = "Midlertidig fredet (etter 1850)";
                break;
            case "Midlertidig fredet (1650-1850) (B4)":
                newItem.key = item;
                newItem.value = "Midlertidig fredet (1650-1850)";
                break;
            default:
                newItem.key = item;
                newItem.value = item;
                break;
            }
            return newItem;
        });

        data.protectionStatus = newProtectionStatus;
    }

    if (data && data.hasOwnProperty("countyNames")) {
        data.countyNames = convertArrayToKeyValue(data.countyNames);
    }

    if (data && data.hasOwnProperty("constructionMaterials")) {
        data.constructionMaterials = convertArrayToKeyValue(
            data.constructionMaterials
        );
    }

    return {
        type: SET_FILTERS,
        data,
    };
}

export function setSearchError(data) {
    return {
        type: SET_SEARCH_ERROR,
        data,
    };
}

// ===========================
// GLOBAL
// ===========================

export function setEraContent(data) {
    return {
        type: SET_ERA_CONTENT,
        data,
    };
}

// ===========================
// HOME
// ===========================
export function setHomepageLoaded() {
    return {
        type: HOMEPAGE_LOADED,
    };
}

export function setFooterPages(data) {
    return {
        type: SET_FOOTER_PAGES,
        data,
    };
}

export function setEraChurches(data) {
    return {
        type: SET_ERA_CHURCHES,
        data,
    };
}

export function setSelectedStories(data) {
    return {
        type: SET_SELECTED_STORIES,
        data,
    };
}

export function setNewsBox(data) {
    return {
        type: SET_NEWS_BOX,
        data,
    };
}

// ===========================
// STORIES
// ===========================
export function setStoryTags(data) {
    return {
        type: SET_STORY_TAGS,
        data,
    };
}

export function setTagsFilter(data) {
    return {
        type: SET_TAGS_FILTER,
        data,
    };
}



// WEBPACK FOOTER //
// ./src/actions/index.js